import type { ProLayoutProps } from "@ant-design/pro-components";

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: "light",
  colorPrimary: "#009040",
  layout: "mix",
  title:'车辆垃圾清运台账管理系统',
  contentWidth: "Fluid",
  fixedHeader: false,
  fixSiderbar: true,
  siderWidth: 200,
  pwa: true,
  logo: "/logo.png",
  token: {},
  splitMenus: false,
  siderMenuType: "sub",
  footerRender: false,
  collapsed:false
};

export default Settings;
